<template>
    <div>
        <div class="tab-box">
            <el-radio-group v-model="activeTab" size="small" @change="refresh">
                <el-radio-button label="task">任务列表</el-radio-button>
                <el-radio-button label="detail">替换详情</el-radio-button>
            </el-radio-group>
        </div>
        <div v-if="activeTab === 'task'">
            <el-form inline size="small">
                <el-form-item label="任务编号">
                    <el-input v-model="searchParams.taskNo" clearable placeholder="请输入任务编号">
                    </el-input>
                </el-form-item>
                <el-form-item label="状态">
                    <el-select v-model="searchParams.status" clearable placeholder="全部">
                        <el-option v-for="item in status_list" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
                    <el-button size="small" @click="refresh">重置</el-button>
                </el-form-item>
            </el-form>
            <div style="margin-bottom: 15px;">
                <el-button plain size="small" @click="handleCheck">AI生成标题</el-button>
            </div>
            <el-table :key="activeTab" v-loading="loading" :data="tableData"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id">
                <el-table-column type="selection" align="center" width="50"
                    :selectable="checkSelectable"></el-table-column>
                <el-table-column label="序号" type="index" align="center" width="80"></el-table-column>
                <el-table-column label="任务编号" prop="task_no" align="center"></el-table-column>
                <el-table-column align="center" label="商品分组" prop="channel" show-overflow-tooltip width="200px">
                    <template #default="{ row }">
                        <!-- <div >{{row.group_id?groupObj[row.group_id]:'' }}</div> -->
                        {{ getGroupNameText(row.group_ids, row.child_group_ids) }}
                    </template>
                </el-table-column>
                <el-table-column label="状态" prop="status_name" align="center">
                </el-table-column>
                <el-table-column label="AI提示词环境" v-if="ismanager" prop="ai_method_name" align="center">
                </el-table-column>
                <el-table-column label="创建时间" prop="created_at" align="center"></el-table-column>
                <el-table-column label="操作" align="center" width="150">
                    <template #default="{ row }">
                        <el-button type="primary" @click="handleStop(row)" v-if="row.status === 2"
                            size="mini">停止</el-button>
                        <el-button type="primary" @click="handleView(row)" size="mini">查看</el-button>
                        <el-button type="primary" @click="handleUpdate(row)" :disabled="row.status <= 2"
                            size="mini">替换</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
                @pagination="getDataList" layout="total, sizes, prev, pager, next, jumper" v-if="page_data.total > 0" />
        </div>

        <div v-if="activeTab === 'detail'">
            <el-form inline size="small">
                <el-form-item label="任务编号">
                    <el-input v-model="searchParams.taskNo" clearable placeholder="请输入任务编号">
                    </el-input>
                </el-form-item>
                <el-form-item label="商品分组">
                    <el-select v-model="searchParams.group_ids" filterable clearable multiple collapse-tags placeholder="全部" @change="changeGroupIds">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="商品子分组">
                    <el-select v-model="searchParams.child_group_ids" filterable clearable multiple collapse-tags placeholder="全部">
                        <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="SKU替换状态">
                    <el-select v-model="searchParams.sku_status" clearable placeholder="全部">
                        <el-option v-for="item in skuWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="标题替换状态">
                    <el-select v-model="searchParams.status" clearable placeholder="全部">
                        <el-option v-for="item in status_list" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" size="small" @click="handleSearch">查询</el-button>
                    <el-button size="small" @click="refresh">重置</el-button>
                </el-form-item>
            </el-form>
            <el-table :key="activeTab" v-loading="loading" :data="tableData" show-overflow-tooltip="false"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }" class="rc_table" row-key="id">
                <el-table-column type="selection" align="center" min-width="30" max-width="80"
                    :selectable="checkSelectable"></el-table-column>
                <el-table-column label="序号" type="index" align="center" min-width="60"
                    max-width="100"></el-table-column>
                <!-- <el-table-column label="任务编号" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.batch?.task_no || '' }}
                    </template>
                </el-table-column> -->
                <!-- <el-table-column label="分组" align="center" min-width="60" max-width="280">
                    <template slot-scope="scope">
                        {{ scope.row.import?.group?.name || '未分组' }}
                    </template>
                </el-table-column> -->
                <el-table-column label="分组|子分组" prop="group_name" align="center" width="150">
                    <template #default="{ row }">
                    <el-tooltip :content="formatGroupName(row)" placement="top" :open-delay="300">
                        <span class="group-name-cell">{{ formatGroupName(row) }}</span>
                    </el-tooltip>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="商品ID" prop="product_id" align="center"></el-table-column> -->
                <el-table-column label="商品信息" min-width="400" max-width="750">
                    <template slot-scope="scope">
                        <div class="goods_wrap">
                            <div class="img_box">
                                <img class="coverimg" :src="scope.row.image" alt="商品图" />
                            </div>
                            <div class="con_box">
                                <p class="info-item">
                                    <span class="label">商品ID：</span><span class="color">{{ scope.row.product_id
                                        }}</span>
                                </p>
                                <p class="info-item">
                                    <span class="label">原：</span><span class="color">{{ scope.row.title }}</span>
                                </p>
                                <p class="info-item">
                                    <span class="label">AI：</span><span class="color">{{ scope.row.new_title }}</span>
                                </p>
                                <p class="info-item" v-if="scope.row.update_title">
                                    <span class="label">改：</span><span class="color">{{ scope.row.update_title }}</span>
                                </p>
                                <p class="info-item edit-row" v-if="scope.row.status !== 1 && scope.row.status !== 2">
                                    <span class="label">修改：</span>
                                    <el-input size="mini" placeholder="在这里输入新标题" v-model="scope.row.edit_title"
                                        class="no-padding-input" style="width: 400px;" />
                                    <el-button size="mini" type="primary" @click="saveEditTitle(scope.row)"
                                        :loading="aiTitleUpdateLoading">
                                        修改
                                    </el-button>
                                </p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="标题" prop="title" align="center"></el-table-column>
                <el-table-column label="AI标题" prop="new_title" align="center"></el-table-column> -->
                <el-table-column label="状态" prop="status_name" align="center" min-width="60"
                    max-width="180"></el-table-column>
                <!-- <el-table-column label="AI提示词环境" v-if="ismanager" prop="ai_method_name"
                    align="center"></el-table-column> -->
                <!-- <el-table-column label="错误码" prop="error_code" align="center"></el-table-column> -->
                <el-table-column label="错误信息" v-if="ismanager" prop="error_msg" align="center"></el-table-column>
                <el-table-column label="AI提示词环境" v-if="ismanager" prop="ai_method_name" align="center">
                </el-table-column>
                <el-table-column label="创建时间" prop="created_at" align="center" min-width="100"
                    max-width="180"></el-table-column>
                <!-- <el-table-column label="修改时间" prop="updated_at" align="center"></el-table-column> -->
                <!-- <el-table-column label="操作" align="center" width="150">
                    <template #default="{ row }">
                        <el-button type="primary" @click="handleUpdate(row)" size="mini">修改</el-button>
                    </template>
                </el-table-column> -->
            </el-table>

            <Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit"
                @pagination="getDetailDataList" layout="total, sizes, prev, pager, next, jumper"
                v-if="page_data.total > 0" />
        </div>
        <!-- 分组表单弹窗 -->
        <el-dialog title="AI生成标题" :visible.sync="aiTitleFormShow" width="600px">
            <el-form label-width="180px" :model="aiTitleForm">
                <el-form-item label="选择商品分组">
                    <el-select v-model="aiTitleForm.group_ids" filterable clearable multiple collapse-tags placeholder="全部"
                        @change="changeGroupIds">
                        <el-option v-for="group in groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="选择商品子分组">
                    <el-select v-model="aiTitleForm.child_group_ids" filterable clearable multiple collapse-tags placeholder="全部">
                        <el-option v-for="group in child_groupList" :key="group.id" :label="group.name"
                            :value="group.id"></el-option>
                    </el-select>
                </el-form-item>
               <el-form-item prop="lexicon_types">
                    <template slot="label">
                        <span>过滤违规词分组：</span>
                        <el-tooltip content="检测管理->关键词检测配置" placement="top" effect="dark">
                            <i class="el-icon-question" style="cursor: pointer;"></i>
                        </el-tooltip>
                    </template>
                    <el-select v-model="aiTitleForm.lexicon_types" clearable multiple collapse-tags placeholder="全部">
                        <el-option v-for="item in dictionaryWordsList" :value="item.id" :label="item.dictionary_name"
                            :key="item.id">
                            <span style="float: left">{{ item.dictionary_name }}</span>
                            <span style="float: right; color: #e6a23c; font-size: 13px"
                                v-if="item.merchant_id === 0">系统</span>
                            <span style="float: right; color: #017eff; font-size: 13px" v-else>自配</span>
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="SKU替换状态：">
                    <el-select v-model="aiTitleForm.sku_status" clearable placeholder="全部">
                        <el-option v-for="item in skuWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="需要生成标题商品：" required>
                    <el-select v-model="aiTitleForm.data_method" placeholder="全部">
                        <el-option v-for="item in checkWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="AI提示词：" v-if="ismanager" required>
                    <el-select v-model="aiTitleForm.ai_method" placeholder="全部">
                        <el-option v-for="item in aiWays" :key="item.value" :label="item.label"
                            :value="item.value"></el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <template #footer>
                <span style="color: red; text-align: center;">选择商品不要超过1万,使用过程会消耗算力。 </span>
                <el-button @click="aiTitleFormShow = false">取消</el-button>
                <el-button type="primary" @click="submitForm" :loading="submitFormLoading">确定</el-button>
            </template>
        </el-dialog>

        <!-- 分组表单弹窗 -->
        <el-dialog title="替换标题" :visible.sync="aiTitleUpdateShow" width="600px">
            <el-form :model="aiTitleUpdateForm">
                <el-form-item label="标题前缀">
                    <el-input v-model="aiTitleUpdateForm.before_word" clearable placeholder="请输入标题前缀"></el-input>
                </el-form-item>
                <!-- <el-form-item label="标题后缀">
                    <el-input v-model="aiTitleUpdateForm.after_word" clearable placeholder="请输入标题后缀"></el-input>
                </el-form-item> -->
                <el-form-item label="待替换词（多关键词逗号分割，例如（2025，2024，纯棉））：" required>
                    <el-input v-model="aiTitleUpdateForm.old_word" clearable placeholder="请输入待替换词"></el-input>
                </el-form-item>
                <el-form-item label="替换词（多关键词逗号分割，（例如2026，2026，棉））：" required>
                    <el-input v-model="aiTitleUpdateForm.new_word" clearable placeholder="请输入替换词"></el-input>
                </el-form-item>
            </el-form>
            <template #footer>
                <el-button @click="aiTitleUpdateShow = false">取消</el-button>
                <el-button type="primary" @click="submitUpdateForm" :loading="aiTitleUpdateLoading">确定</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";

import Pagination from "@/components/pagination/pagination.vue";

export default {
    props: {
        groupList: {
            type: Array,
            default: []
        },
    },
    components: {
        Pagination,
    },
    computed: {
        ...mapState({
            users: (state) => state.login.userinfo
        }),
    },
    data() {
        return {
            isManager: false,
            activeTab: 'task',
            aiTitleFormShow: false,
            submitFormLoading: false,
            aiTitleUpdateShow: false,
            aiTitleUpdateLoading: false,
            loading: false,
            tableData: [],
            page_data: {
                limit: 10,
                page: 1,
                total: 0,
            },
            searchParams: {
                status: '',
                taskNo: '',
                sku_status: '',
                group_ids: [],
                child_group_ids: [],
            },
            aiTitleUpdateForm: {
                id: '',
                old_word: '',
                new_word: '',
                before_word: '',
                after_word: '',
            },
            selectData: [],
            aiTitleForm: { group_ids: [], child_group_ids:[], lexicon_types: [], data_method: 1, ai_method: 1, sku_status: '' },
            checkWays: [{ label: '未生成AI标题商品', value: 2 }, { label: '全部商品', value: 1 }],
            skuWays: [{ label: '未替换', value: 1 }, { label: '已替换', value: 2 }, { label: '找不到', value: 3 }],
            aiWays: [{ label: '正式AI提示词', value: 1 }, { label: '测试AI提示词', value: 2 }],
            status_list: [{ label: '待处理', value: 1 }, { label: '处理中', value: 2 }, { label: '处理完成', value: 3 }, { label: '已取消', value: 4 }, { label: '异常', value: 9 }],
            child_groupList: [],
            dictionaryWordsList: [],
        }
    },
    created() {
        this.ismanager = (this.users.mer_user_id === '1' || this.users.mer_user_id === '666')
        // this.$emit('update:is-manager', this.ismanager)
    },
    methods: {
        ...mapActions({
            opGetAIReplaceTitleList: 'ucenter/opGetAIReplaceTitleList',
            opGetAIReplaceTitleDetail: 'ucenter/opGetAIReplaceTitleDetail',
            opPostAIReplaceTitle: 'ucenter/opPostAIReplaceTitle',
            opPutAIReplaceTitle: 'ucenter/opPutAIReplaceTitle',
            opPutAIReplaceTitleDetail: 'ucenter/opPutAIReplaceTitleDetail',
            opUpdateAIReplaceBatchTitleDetail: 'ucenter/opUpdateAIReplaceBatchTitleDetail',
            opGetDictionaryWords: 'ucenter/opGetDictionaryWords',
        }),
        initData() {
            this.refresh()
            this.getDictionaryWords()
        },
        checkSelectable(row) {
            if (row.merchant_id === 0) {
                return this.ismanager === true;
            }
            return true;
        },
        getDataList() {
            this.tableData = []
            this.loading = true
            let param = { page_size: this.page_data.limit, page: this.page_data.page, batch_id: this.batchId, ...this.searchParams }
            this.opGetAIReplaceTitleList({
                data: param,
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.tableData = res.data.list
                        this.page_data.total = res.data.total
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        getDetailDataList() {
            this.tableData = []
            this.loading = true
            let param = { page_size: this.page_data.limit, page: this.page_data.page, batch_id: this.batchId, ...this.searchParams }
            this.opGetAIReplaceTitleDetail({
                data: param,
                success: (res) => {
                    this.loading = false
                    if (res.code == 200) {
                        this.tableData = res.data.list
                        this.tableData = this.tableData.map(row => {
                            // 重点在这里！必须用 $set 让视图响应
                            this.$set(row, 'edit_title', row.update_title || row.new_title || row.title)
                            return row
                        })
                        this.page_data.total = res.data.total
                    } else {
                        this.$message.error(res.message)
                    }

                }
            })
        },
        handleSearch() {
            if (this.activeTab == 'task') {
                this.page_data.page = 1
                this.getDataList()
            } else {
                this.page_data.page = 1
                this.getDetailDataList()
            }
        },
        refresh() {
            this.tableData = []
            this.page_data.page = 1
            this.page_data.total = 0
            this.child_groupList = []
            this.searchParams = {
                status: '',
                taskNo: '',
                sku_status: '',
                group_ids: [],
                child_group_ids: [],
            }
            if (this.activeTab == 'task') {
                this.getDataList()
            } else {
                this.getDetailDataList()
            }

        },
        handleView(row) {
            this.activeTab = 'detail'
            this.page_data.page = 1
            this.page_data.total = 0
            this.searchParams = {
                status: '',
                sku_status: '',
                group_ids: [],
                taskNo: row?.task_no || '',
            }
            this.getDetailDataList()
        },
        handleUpdate(row) {
            if (row.status === 1 || row.status === 2) {
                this.$message.error('待处理和处理中的状态无法替换标题!')
                return;
            }
            this.aiTitleUpdateShow = true;
            this.aiTitleUpdateForm.id = row.id
            // if (row.status === 3) {
            //     this.aiTitleUpdateForm.title = row.new_title
            // } else {
            //     this.aiTitleUpdateForm.title = row.title
            // }
            // if (row.update_title) {
            //     this.aiTitleUpdateForm.title = row.update_title
            // }
        },
        handleStop(row) {
            this.$confirm(`是否停止${row.task_no}任务，标题已提交AI的链接会继续执行。`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                const id = row.id
                this.opPutAIReplaceTitle({
                    data: id,
                    success: (res) => {
                        this.page_data.page = 1
                        this.page_data.total = 0
                        this.searchParams = {
                            status: '',
                            taskNo: '',
                            sku_status: '',
                            group_ids: [],
                        }
                        this.getDataList()
                        if (res.code == 200) {
                            this.$message.success(res.message)
                        } else {
                            this.$message.error(res.message)
                        }
                    }
                })

            }).catch(() => { })

        },
        // === 新增 ===
        handleAdd() {
            this.addShow = true
            this.addInfo = { type: '', lexicon_type: "", keywords: "" }
            this.$nextTick(() => {
                this.$refs.addForm.resetFields()
            })
        },
        submitForm() {
            this.submitFormLoading = true
            this.opPostAIReplaceTitle({
                data: this.aiTitleForm,
                success: (res) => {
                    this.submitFormLoading = false
                    if (res.code == 200) {
                        this.aiTitleFormShow = false
                        this.$message.success(res.message)
                        this.getDataList()
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        submitUpdateForm() {
            this.aiTitleUpdateLoading = true
            if (!this.aiTitleUpdateForm.old_word) {
                this.$message.error('请输入待替换词')
                this.aiTitleUpdateLoading = false
                return
            }
            if (!this.aiTitleUpdateForm.new_word) {
                this.$message.error('请输入替换词')
                this.aiTitleUpdateLoading = false
                return
            }
            if (!this.aiTitleUpdateForm.id) {
                this.$message.error('请选择批次')
                this.aiTitleUpdateLoading = false
                return
            }
            // 统一分割方法（支持中英文逗号）
            const splitWords = (str) => {
                return str.replace(/，/g, ',').split(',').map(i => i.trim()).filter(Boolean)
            }

            const oldArr = splitWords(this.aiTitleUpdateForm.old_word)
            const newArr = splitWords(this.aiTitleUpdateForm.new_word)

            if (oldArr.length !== newArr.length) {
                this.$message.error('待替换词与替换词的数量不匹配，请保持一致！')
                this.aiTitleUpdateLoading = false
                return
            }
            this.opUpdateAIReplaceBatchTitleDetail({
                data: { 'id': this.aiTitleUpdateForm.id, 'old_word': oldArr, 'new_word': newArr, 'before_word': this.aiTitleUpdateForm.before_word, 'after_word': this.aiTitleUpdateForm.after_word },
                success: (res) => {
                    this.aiTitleUpdateLoading = false
                    if (res.code == 200) {
                        this.aiTitleUpdateShow = false
                        this.$message.success(res.message)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        handleCheck() {
            this.child_groupList = []
            this.aiTitleFormShow = true
            this.aiTitleForm.lexicon_types = []
            this.aiTitleForm.group_ids = []
            this.aiTitleForm.child_group_ids = []
            this.aiTitleForm.data_method = 1
            this.aiTitleForm.ai_method = 1
            this.sku_status = ''
        },
        getGroupNameText(groupId, child_group_ids, flag = 0) {
            if (!groupId && flag === 0) return '全部'
            let ids = []
            if (typeof groupId === 'string') {
                try {
                    ids = JSON.parse(groupId)
                } catch (e) {
                    ids = groupId.split(',').map(item => item.trim())
                }
            } else {
                ids = Array.isArray(groupId) ? groupId : [groupId]
            }

            // 统一处理 child_group_ids 为数组
            let childIds = []
            if (typeof child_group_ids === 'string') {
                try {
                    childIds = JSON.parse(child_group_ids)
                } catch (e) {
                    childIds = child_group_ids.split(',').map(item => item.trim())
                }
            } else {
                childIds = Array.isArray(child_group_ids) ? child_group_ids : (child_group_ids ? [child_group_ids] : [])
            }

            return ids.filter(id => id) // 去掉空ID
                .map(id => this.groupList.find(item => item.id === id)) // 用ID匹配数组
                .filter(Boolean) // 过滤找不到的
                .map(item => {
                    let name = item.name
                    // 判断 item.child_groups 是否有值，并筛选出 id 存在于 child_group_ids 中的子分组
                    if (item.child_groups && item.child_groups.length > 0 && childIds.length > 0) {
                        const matchedChildNames = item.child_groups
                            .filter(child => childIds.includes(child.id))
                            .map(child => child.name)
                        // 如果有匹配的子分组，则用括号拼接展示
                        if (matchedChildNames.length > 0) {
                            name += `（${matchedChildNames.join('、')}）`
                        }
                    }
                    return name
                })
                .join('、')
        },

        saveEditTitle(row) {
            if (!row.id) {
                this.$message.warning('id不能为空')
                return
            }
            let title = row.edit_title?.trim()
            if (!title) {
                this.$message.warning('请输入新标题')
                return
            }
            let len = title.replace(/[^\x00-\xff]/g, 'xx').length
            if (len < 8) {
                this.$message.warning('商品名称最少需要输入 4 个汉字（8个字符）')
                return
            }
            if (len > 60) {
                this.$message.warning('商品名称最多只能输入 30 个汉字（60个字符）')
                return
            }
            this.aiTitleUpdateLoading = true
            this.aiTitleUpdateForm.id = row.id
            this.aiTitleUpdateForm.title = title
            this.opPutAIReplaceTitleDetail({
                id: this.aiTitleUpdateForm.id,
                data: this.aiTitleUpdateForm,
                success: (res) => {
                    this.aiTitleUpdateLoading = false
                    if (res.code == 200) {
                        this.aiTitleUpdateShow = false
                        row.update_title = row.edit_title
                        this.$message.success(res.message)
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        changeGroupIds(val) {
            this.$set(this.aiTitleForm, 'child_group_ids', '')
            this.$set(this.searchParams, 'child_group_ids', '')
            this.child_groupList = this.groupList.filter(i => val.includes(i.id)).map(i => i.child_groups || []).flat()
        },
        getDictionaryWords() {
            this.opGetDictionaryWords({
                data: { 'dictionary_type': 1 },
                success: (res) => {
                    if (res.code == 200) {
                        let list = res.data || [];
                        list.sort((a, b) => (a.merchant_id === 0 ? -1 : 0));
                        this.dictionaryWordsList = list;
                        // this.dictionaryWordsList = res.data || []
                    } else {
                        this.$message.error(res.message)
                    }
                }
            })
        },
        formatGroupName(row) {
            let group_id = row.import?.group_id || '-'
            let group_name = this.groupList.find(i => i.id === group_id)?.name || '-'
            let child_group_id = row.import?.child_group_id || '-'
            const target = this.groupList.find(i => i.id === group_id)?.child_groups?.find(i => i.id === child_group_id)
            const child_group_name = target?.name || null
            if(child_group_name) {
                group_name += '|'+child_group_name
            }
            return group_name;
        },
    }
}
</script>


<style scoped>
.tab-box {
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
}

.w_120 {
    width: 150px;
}

.w_220 {
    width: 220px;
}

.goods_wrap {
    display: flex !important;
    align-items: flex-start !important;
    gap: 8px !important;
    width: 100% !important;
    box-sizing: border-box !important;
}

/* 图片固定大小，不缩放变形 */
.img_box {
    width: 110px !important;
    height: 110px !important;
    flex-shrink: 0 !important;
}

.coverimg {
    width: 100% !important;
    height: 100% !important;
    object-fit: cover !important;
    border-radius: 4px !important;
}

/* 内容区域自动适配 */
.con_box {
    flex: 1 !important;
    min-width: 0 !important;
    width: 100% !important;
}

/* 每行信息样式 */
.info-item {
    display: flex !important;
    align-items: center !important;
    font-size: 12px !important;
    margin: 0 0 3px 0 !important;
    line-height: 1.3 !important;
    width: 100% !important;
    white-space: normal !important;
    word-wrap: break-word !important;
}

/* 标签固定宽度，统一对齐 */
.label {
    min-width: 44px !important;
    flex-shrink: 0 !important;
    color: #666 !important;
    margin-right: 4px !important;
    font-size: 12px !important;
}

/* 标题文字自动换行，不撑破布局 */
.color {
    flex: 1 !important;
    word-break: break-all !important;
    white-space: normal !important;
}

/* ========== 修改输入框：全屏幕自动适配 ========== */
.edit-row {
    display: flex !important;
    align-items: center !important;
    width: 100% !important;
}

.edit-row .el-input {
    flex: 1 !important;
    max-width: 450px !important;
    min-width: 160px !important;
    width: auto !important;
}

.edit-row .el-button {
    flex-shrink: 0 !important;
    margin-left: 6px !important;
}

/* ========== 表格核心：允许内容自动换行 + 不隐藏 ========== */
.el-table .cell {
    white-space: normal !important;
    overflow: visible !important;
    height: auto !important;
    padding: 6px 0 !important;
}

/* 每行信息：自己占一行，但内容不换行 */
.info-item {
    font-size: 13px;
    color: #333;
    margin: 0 0 4px 0;
    line-height: 1.4;

    /* 关键：本行内部不换行 */
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* 标签灰色 */
.label {
    color: #666;
    margin-right: 4px;
}

/* 内容蓝色 */
.color {
    font-size: 12px;
    color: #0096ff;
}

/* 小屏幕自动适配：搜索表单缩小 + 自动换行 */
@media (max-width: 1445px) {
    .el-form--inline .el-form-item {
        margin-right: 8px !important;
        /* 缩小间距 */
    }

    .el-form--inline .el-form-item__label {
        padding: 0 6px !important;
        /* 标签间距缩小 */
        font-size: 12px !important;
        /* 标签文字变小 */
    }

    .el-form--inline .el-input,
    .el-form--inline .el-select {
        width: 130px !important;
        /* 输入框/下拉框变窄 */
    }

    .el-form--inline .el-button {
        padding: 6px 10px !important;
        /* 按钮变小 */
        font-size: 15px !important;
    }

    .img_box {
        width: 80px !important;
        height: 80px !important;
        flex-shrink: 0 !important;
    }

    .el-table,
    .el-table__cell,
    .info-item,
    .label,
    .color {
        font-size: 12px !important;
    }

    .no-padding-input>>>.el-input__inner {
        /* padding: 0 !important; */
        padding-left: 5px !important;
    }
}
</style>
